import React from 'react';

import styles from './Message.module.css';

type Props = {
  title?: string;
  text?: string;
};

export const Message: React.FC<Props> = ({ title, text }) => {
  if (!text && !title) {
    return null;
  }

  return (
    <div className={styles.root}>
      {title && <div className={styles.title}>{title}</div>}
      {text && <div className={styles.text}>{text}</div>}
    </div>
  );
};
